import { useNavigate } from 'react-router-dom';
import { X, LayoutDashboard, Users, FolderKanban, CheckSquare, Calendar, Mail, FileText, ReceiptEuro, Settings, Inbox, Car, Wrench, Fuel, Landmark, Wallet, ClipboardList, Image, BookOpen, BookText, AlertTriangle, Sparkles, Video, Megaphone, CalendarClock } from 'lucide-react';
import { useTabs, naechsterTabNachSchliessen } from '../../contexts/TabContext';

const ICONS = {
  CalendarClock,
  LayoutDashboard,
  Users,
  FolderKanban,
  CheckSquare,
  Calendar,
  Mail,
  FileText,
  ReceiptEuro,
  Settings,
  Inbox,
  Car,
  Wrench,
  Fuel,
  Landmark,
  Wallet,
  ClipboardList,
  Image,
  BookOpen,
  BookText,
  AlertTriangle,
  Sparkles,
  Video,
  Megaphone,
};

export function TabBar() {
  const navigate = useNavigate();
  const { tabs, activeTabId, activateTab, closeTab } = useTabs();

  const handleTabClick = (tab) => {
    activateTab(tab.id);
    // Virtuelle Tabs (z. B. E-Mail-Composer) haben keine Route – nur Callback.
    if (!tab.virtual && tab.path) {
      navigate(tab.path);
    }
  };

  const handleCloseTab = (e, tabId) => {
    e.stopPropagation();
    
    // Nächsten Tab bestimmen, bevor wir schließen (Herkunfts-Tab samt Herkunftsort bevorzugt)
    const nextTab = naechsterTabNachSchliessen(tabs, tabId);
    
    closeTab(tabId);
    
    // Wenn der aktive Tab geschlossen wurde, navigiere zum nächsten Tab
    if (activeTabId === tabId && nextTab && !nextTab.virtual && nextTab.path) {
      navigate(nextTab.path);
    }
  };

  if (tabs.length <= 1) return null; // Nur Dashboard, keine Tab-Leiste nötig

  return (
    <div className="hidden md:flex bg-white border-b border-gray-200 px-2 items-center overflow-x-auto scrollbar-thin scrollbar-thumb-gray-300">
      {tabs.map((tab) => {
        const Icon = ICONS[tab.icon] || FileText;
        const isActive = tab.id === activeTabId;
        
        return (
          <div
            key={tab.id}
            onClick={() => handleTabClick(tab)}
            className={`
              group flex items-center gap-2 px-3 py-2 cursor-pointer border-b-2 
              min-w-[120px] max-w-[200px] transition-colors
              ${isActive 
                ? 'border-blue-600 bg-blue-50 text-blue-700' 
                : 'border-transparent hover:bg-gray-100 text-gray-600 hover:text-gray-900'
              }
            `}
            data-testid={`tab-${tab.id}`}
          >
            <Icon className="w-4 h-4 flex-shrink-0" />
            <span className="truncate text-sm font-medium">{tab.title}</span>
            
            {tab.closable && (
              <button
                onClick={(e) => handleCloseTab(e, tab.id)}
                className={`
                  ml-auto p-0.5 rounded hover:bg-gray-200 
                  ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}
                  transition-opacity
                `}
                data-testid={`close-tab-${tab.id}`}
              >
                <X className="w-3.5 h-3.5" />
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default TabBar;
